<div class="auto-text-item">
  <label *ngIf="!firstRow">
    <input type="checkbox" class="sr-only" [(ngModel)]="isChecked" (change)="addText()" />
    <span class="auto-text-checkbox"></span>
  </label>
  <div class="auto-text-input" *ngIf="edit" dir="auto">
    <textarea
      type="text"
      [(ngModel)]="Text"
      [placeholder]="'GUI.Placeholders.Enter a new text sentence' | translate"
      dir="auto"
    ></textarea>
  </div>
  <div
    class="auto-text-txt"
    *ngIf="!edit"
    dir="auto"
    style="
      cursor: pointer;
      white-space: pre-wrap;
      text-align: right;
      width: 100%;
      display: block;
      box-sizing: border-box;
      padding: 0.5em;
    "
    (click)="isChecked = !isChecked; addText()"
  >
    {{ Text }}
  </div>
  <div class="auto-text-controls">
    <button
      class="auto-text-priority-button"
      matTooltip="Move Up"
      *ngIf="!edit && (ls.isAdmin || (!ls.isAdmin && atS.filter)) && !isFirst && id !== null"
      (click)="moveUp()"
    >
      ▲
    </button>
    <button
      class="auto-text-priority-button"
      matTooltip="Move Down"
      *ngIf="!edit && (ls.isAdmin || (!ls.isAdmin && atS.filter)) && !isLast && id !== null"
      (click)="moveDown()"
    >
      ▼
    </button>
    <button
      class="auto-text-add-button"
      matTooltip="Move Autotext to User"
      *ngIf="!edit && !atS.filter && ls.isCardio && (ls.isAdmin || (!ls.isAdmin && !atS.filter))"
      (click)="save(true)"
    >
      Add
    </button>
    <button
      class="auto-text-delete-button"
      *ngIf="!edit && (ls.isAdmin || (!ls.isAdmin && atS.filter))"
      (click)="delete()"
    >
      Delete
    </button>
    <button
      class="auto-text-edit-button"
      *ngIf="!edit && (ls.isAdmin || (!ls.isAdmin && atS.filter))"
      (click)="setEdit()"
    >
      Edit
    </button>
    <button
      class="auto-text-done-button"
      *ngIf="edit && Text != '' && (ls.isAdmin || (!ls.isAdmin && atS.filter))"
      (click)="save()"
    >
      Done
    </button>
  </div>
</div>
